var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1121_14446",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1121_14446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70803 5.39998C5.4532 5.39998 5.23828 5.31423 5.06328 5.14273C4.88828 4.97123 4.80078 4.75873 4.80078 4.50523C4.80078 4.25173 4.88695 4.03748 5.05928 3.86248C5.23178 3.68748 5.44545 3.59998 5.70028 3.59998H18.2935C18.5484 3.59998 18.7633 3.68573 18.9383 3.85723C19.1133 4.02873 19.2008 4.24123 19.2008 4.49472C19.2008 4.74822 19.1146 4.96248 18.9423 5.13748C18.7698 5.31248 18.5561 5.39998 18.3013 5.39998H5.70803ZM12.006 20.4C11.7525 20.4 11.5383 20.3137 11.3633 20.1412C11.1883 19.9687 11.1008 19.755 11.1008 19.5V10.65L9.10078 12.625C8.91745 12.8083 8.70495 12.9 8.46328 12.9C8.22162 12.9 8.00912 12.8083 7.82578 12.625C7.64245 12.4416 7.55078 12.2333 7.55078 12C7.55078 11.7666 7.64128 11.5595 7.82228 11.3785L11.3758 7.82498C11.4658 7.74164 11.5633 7.67914 11.6683 7.63748C11.7733 7.59581 11.8858 7.57498 12.0058 7.57498C12.1258 7.57498 12.2383 7.59581 12.3433 7.63748C12.4483 7.67914 12.5424 7.74164 12.6258 7.82498L16.156 11.3552C16.3359 11.5351 16.4258 11.7458 16.4258 11.9875C16.4258 12.2291 16.3341 12.4416 16.1508 12.625C15.9675 12.8083 15.7591 12.9041 15.5258 12.9125C15.2924 12.9208 15.0841 12.8333 14.9008 12.65L12.9008 10.65V19.5C12.9008 19.755 12.815 19.9687 12.6435 20.1412C12.472 20.3137 12.2595 20.4 12.006 20.4Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.317e5d60d7d5ab6869041036290899df.svg";
export { ForwardRef as ReactComponent };